import { useAudioVideo } from '@providers/AudioVideoProvider';
import { useVideoInputs } from '@providers/DevicesProvider';
import { useLocalVideo } from '@providers/LocalVideoProvider';
import { useEffect, useState } from 'react';

export function useInterviewerCameraOn(isCameraOn = true) {
  const { tileId, isVideoEnabled, toggleVideo } = useLocalVideo();
  const { selectedDevice } = useVideoInputs();
  const audioVideo = useAudioVideo();

  const [isInit, setIsInit] = useState(false);

  useEffect(() => {
    if (!tileId) return;
    setIsInit(true);

    if (isCameraOn && !isVideoEnabled) toggleVideo();
    if (!isCameraOn && isVideoEnabled) toggleVideo();
  }, [tileId]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (audioVideo?.hasStartedLocalVideoTile()) clearInterval(intervalId);
      audioVideo?.startLocalVideoTile();
    }, 400);
  }, [audioVideo]);

  useEffect(() => {
    if (!selectedDevice) return;

    if (!isVideoEnabled && isInit && isCameraOn) toggleVideo();
  }, [selectedDevice, isInit]);
}
